/* eslint-disable */
import React from "react";
import { SmartImg, computeContentCenter } from "../utils";
import { ErrorBoundary } from "../ErrorBoundary";
import OriginalsCard from "./originals/OriginalsCard";
import { useShellStore } from "./shell/shellStore";
import OriginalsCardV3 from "./shell/cards/OriginalsCardV3";
import OriginalsBulkBar from "./shell/originals/OriginalsBulkBar";

function BrandedPlaceholder({ size = "normal" }) {
  const s = size === "list" ? 20 : 40;
  return (
    <div style={{ width:"100%", height:"100%", display:"flex", alignItems:"center", justifyContent:"center", background:"#fafaf8" }}>
      <svg width={s} height={s} viewBox="0 0 40 40" fill="none" style={{ opacity:0.08 /* step-13-deferred: decorative placeholder SVG below faint (0.15) floor */ }}>
        <rect x="4" y="8" width="32" height="18" rx="9" stroke="var(--text)" strokeWidth="2.5"/>
        <circle cx="14" cy="17" r="5" stroke="var(--text)" strokeWidth="2"/>
        <circle cx="26" cy="17" r="5" stroke="var(--text)" strokeWidth="2"/>
        <path d="M2 17h4M34 17h4" stroke="var(--text)" strokeWidth="2" strokeLinecap="round"/>
      </svg>
    </div>
  );
}

export function CatalogView({
  items, pagedItems, totalCount, pageLoading, loaded, viewMode, isMobile, catalogCols,
  selectedItems, setSelectedItems, setSelected, setHoverPreview, recentlyUploaded,
  toggleFavorite, isFav, hasMore, loadMoreItems, isCurrentlyFiltered, stats,
  fBrand, setFBrand, fGender, setFGender, fType, setFType, fMat, setFMat,
  fShape, setFShape, fStatus, setFStatus, fAssigned, setFAssigned, fCreatedBy, setFCreatedBy,
  debouncedSearch, clearAllFilters, fields, perm,
  handleBulkStatus, handleBulkAssign, refreshAllItemsStats, showToast,
  T, cardSt, inputSt, supabase,
  // T-1015 — Map<item_id, dev[]> for grid card "↩ N devs" eyebrow (Feature X)
  linkedDevsMap,
}) {
  // Shell v3 (CLB-012 S3) — under the flag the card, the grid geometry and the
  // bulk bar are the prototype's; the two bulk writes below are shared by both.
  const shellV3 = useShellStore((st) => st.active);
  const density = useShellStore((st) => st.density);
  const Card = shellV3 ? OriginalsCardV3 : OriginalsCard;
  const bulkStatus = async (val) => {
    for (const id of [...selectedItems]) { const item=items.find(i=>i.id===id); if(!item) continue; const upd={...item,status:val}; await supabase.from("items").update({data:upd}).eq("id",String(id)); }
    refreshAllItemsStats();
    setSelectedItems(new Set()); showToast(`Updated status for ${selectedItems.size} items`);
  };
  const bulkAssign = async (val) => {
    for (const id of [...selectedItems]) { const item=items.find(i=>i.id===id); if(!item) continue; const upd={...item,assignedTo:val}; await supabase.from("items").update({data:upd}).eq("id",String(id)); }
    setSelectedItems(new Set()); showToast(`Assigned ${selectedItems.size} items to ${val}`);
  };
  return (
    <ErrorBoundary><>
      {/* Brief E.3 polish phase 1 — legacy "items found" strip removed; BarLeft is the canonical count/filter display. */}

      {shellV3 && <OriginalsBulkBar items={items} selectedItems={selectedItems} setSelectedItems={setSelectedItems} perm={perm} fields={fields} onBulkStatus={bulkStatus} onBulkAssign={bulkAssign} />}

      {/* Bulk Edit Bar */}
      {!shellV3 && selectedItems.size>0 && perm.canEdit && (
        <div style={{ ...cardSt, padding:"var(--space-md) var(--space-lg)", marginBottom:'var(--space-md)', display:"flex", alignItems:"center", gap:'var(--space-md)', flexWrap:"wrap", background:T.accent+"12", borderColor:T.accent+"44" }}>
          <span style={{ fontSize:'var(--text-xs)', fontWeight:'var(--weight-bold)', color:T.accent }}>✏️ Bulk Edit {selectedItems.size} items:</span>
          <select defaultValue="" onChange={async e => {
            const val=e.target.value; if(!val) return;
            await bulkStatus(val); e.target.value="";
          }} style={{ ...inputSt, width:"auto", fontSize:'var(--text-xs)' }}>
            <option value="">Set Status...</option>
            {(fields.find(f=>f.key==="status")?.options||[]).map(o=><option key={o}>{o}</option>)}
          </select>
          <select defaultValue="" onChange={async e => {
            const val=e.target.value; if(!val) return;
            await bulkAssign(val); e.target.value="";
          }} style={{ ...inputSt, width:"auto", fontSize:'var(--text-xs)' }}>
            <option value="">Assign To...</option>
            {(fields.find(f=>f.key==="assignedTo")?.options||[]).map(o=><option key={o}>{o}</option>)}
          </select>
          {/* Phase 1 follow-up — Clear selection restored inside Bulk Edit Bar (was in deleted count strip) */}
          <button onClick={()=>setSelectedItems(new Set())} style={{ marginLeft:'auto', fontSize:'var(--text-2xs)', color:T.textMuted, background:"none", border:"var(--border-thin) solid var(--border)", borderRadius:'var(--radius-xs)', padding:"var(--space-2xs) var(--space-sm)", cursor:"pointer" }}>Clear selection</button>
        </div>
      )}

      {/* Brief E.3 polish phase 1 — legacy active-filter chips row removed; BarLeft is the canonical chips display. */}

      {/* GRID VIEW */}
      {viewMode === "grid" && (
        <div className={shellV3 ? undefined : "catalog-grid"} data-cols={catalogCols} data-shell-grid={shellV3 ? density : undefined} style={{ opacity:pageLoading?0.5:1, transition:"opacity .15s", ...(shellV3 ? { display:"grid", gap: density === "compact" ? 10 : 12, gridTemplateColumns: isMobile ? "repeat(2, minmax(0, 1fr))" : `repeat(auto-fill, minmax(${density === "compact" ? 262 : 330}px, 1fr))` } : {}) }}>
          {pagedItems.map(item => (
            <Card
              key={item.id}
              item={item}
              isSelected={selectedItems.has(item.id)}
              isFav={isFav(item.id, "catalog")}
              linkedCount={linkedDevsMap?.get(item.id)?.length || 0}
              priority={recentlyUploaded.has(item.id)}
              hoverPreviewEnabled={T.hoverPreviewEnabled !== false}
              onOpen={() => setSelected(item)}
              onToggleSelect={() => setSelectedItems(prev => { const s = new Set(prev); s.has(item.id) ? s.delete(item.id) : s.add(item.id); return s; })}
              onToggleFav={() => toggleFavorite(item.id, "catalog")}
              onHoverPreview={(hp) => setHoverPreview(hp)}
              onHoverPreviewEnd={() => setHoverPreview(null)}
            />
          ))}
        </div>
      )}

      {/* LIST VIEW */}
      {viewMode === "list" && (
        <div style={{ ...cardSt, overflow:"hidden" }}>
          <div style={{ display:"grid", gridTemplateColumns:"72px 1fr 110px 110px 110px 120px 160px", padding:"var(--space-md) var(--space-xl)", borderBottom:`var(--border-med) solid ${T.border}`, fontSize:'var(--text-2xs)', color:T.textMuted, fontWeight:800, textTransform:"uppercase", letterSpacing:".06em" }}>
            <span>Photo</span><span>Model</span><span>SKU</span><span>Frame</span><span>Material</span><span>Location</span><span>Holder</span>
          </div>
          {pagedItems.map((item,i) => (
            <div key={item.id} onClick={() => setSelected(item)}
              style={{ display:"grid", gridTemplateColumns:"72px 1fr 110px 110px 110px 120px 160px", padding:"var(--space-md) var(--space-xl)", borderBottom:i<pagedItems.length-1?`1px solid ${T.border}`:"none", cursor:"pointer", alignItems:"center", transition:"background .1s" }}
              onMouseEnter={e=>e.currentTarget.style.background=T.mainBg}
              onMouseLeave={e=>e.currentTarget.style.background="transparent"}>
              <div style={{ width:48, height:36, borderRadius:'var(--radius-lg)', overflow:"hidden", background:T.mainBg, display:"flex", alignItems:"center", justifyContent:"center" }}>
                {(item.images||[]).length>0||item.image?<SmartImg src={(item.images||[])[0]||item.image} displayWidth={80} alt="" style={{ width:"100%", height:"100%", objectFit:"contain", background:"var(--card-bg)" }}/>:<BrandedPlaceholder size="list" />}
              </div>
              <div>
                <div style={{ fontWeight:'var(--weight-bold)', fontSize:'var(--text-sm)', color:T.textPrimary, fontFamily:T.displayFont }}>{item.model||item.sku||"—"}</div>
                <div style={{ fontSize:'var(--text-xs)', color:T.textMuted }}>{item.brand}</div>
              </div>
              <span style={{ fontSize:'var(--text-xs)', color:T.textSecondary }}>{item.sku}</span>
              <span style={{ fontSize:'var(--text-xs)', color:T.textSecondary }}>{item.frameType}</span>
              <span style={{ fontSize:'var(--text-xs)', color:T.textSecondary }}>{item.material}</span>
              <span style={{ fontSize:'var(--text-xs)', color:T.textMuted }}>📍 {item.location}</span>
              <span style={{ fontSize:'var(--text-xs)', color:T.textSecondary, fontWeight:'var(--weight-semi)' }}>{item.assignedTo?`👤 ${item.assignedTo}`:"🏬 In Warehouse"}</span>
            </div>
          ))}
        </div>
      )}

      {/* Footer — count + load more */}
      {totalCount > 0 && (
        <div style={{ height:36, background:"var(--card-bg)", borderTop:"var(--border-thin) solid var(--border)", display:"flex", alignItems:"center", justifyContent:"space-between", padding:"0 var(--space-xl)", marginTop:'var(--space-sm)', fontFamily:"var(--font-ui)" }}>
          <span style={{ fontSize:'var(--text-xs)', color:"#ccc" }}>{isCurrentlyFiltered ? `${totalCount.toLocaleString()} items found` : `Showing ${items.length.toLocaleString()} of ${totalCount.toLocaleString()} items`}</span>
          {hasMore && (
            <button onClick={loadMoreItems} disabled={pageLoading}
              style={{ background:"none", border:"none", cursor:"pointer", fontFamily:"inherit", fontSize:'var(--text-xs)', fontWeight:'var(--weight-semi)', letterSpacing:"1.5px", textTransform:"uppercase", color:"var(--gold)", transition:"border-color .15s ease", opacity:pageLoading?0.5:1 }}
              onMouseEnter={e=>{e.currentTarget.style.color="#c49e64";e.currentTarget.style.letterSpacing="2px";}}
              onMouseLeave={e=>{e.currentTarget.style.color="var(--gold)";e.currentTarget.style.letterSpacing="1.5px";}}>
              {pageLoading ? "Loading..." : "Load More"}
            </button>
          )}
        </div>
      )}
      {totalCount === 0 && loaded && (
        <div style={{ ...cardSt, textAlign:"center", padding:"60px 0", fontFamily:"var(--font-ui)" }}>
          <div style={{ display:"flex", justifyContent:"center", marginBottom:'var(--space-lg)'}}>
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="var(--sandstone)" strokeWidth="1.5" aria-hidden="true">
              <circle cx="11" cy="11" r="7" />
              <line x1="16" y1="16" x2="21" y2="21" />
            </svg>
          </div>
          <div style={{ fontSize:'var(--text-md)', fontWeight:'var(--weight-bold)', color:T.textPrimary }}>No models found</div>
          <div style={{ fontSize:'var(--text-xs)', color:T.textMuted, marginTop:'var(--space-xs)'}}>Try other filters</div>
        </div>
      )}
    </></ErrorBoundary>
  );
}
